import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { JobSummary } from 'src/shared/api';
import { displayJobStatusAdmin } from 'src/shared/enums';
import { BehaviorSubject } from 'rxjs';
import { jobsFragments } from 'src/admin-app/jobs/jobs.routes';
import { quotesFragments } from 'src/admin-app/quotes/quotes.routes';

@Component({
	selector: 'rpfsa-job-list',
	templateUrl: './job-list.component.html',
	styleUrls: ['./job-list.component.scss'],
})
export class JobListComponent implements AfterViewInit {
	private loading = new BehaviorSubject<boolean>(true);
	loading$ = this.loading.asObservable();

	@Input()
	set jobs(jobs: JobSummary[]) {
		if (jobs) {
			this.loading.next(false);
			this.dataSource.data = jobs;
		}
	}

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	emptyColumns = ['empty'];
	resultColumns = ['number', 'status', 'start', 'end', 'description'];

	jobsFragments = jobsFragments;
	quotesFragments = quotesFragments;
	dataSource = new MatTableDataSource<JobSummary>([]);

	// Redeclared Template Variables
	displayJobStatusAdmin = displayJobStatusAdmin;

	constructor(readonly router: Router) {}

	ngAfterViewInit() {
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginator;
	}
}
